<template>
  <v-container>
    <v-row justify="center">
      <!-- components instructions to connect tools dialog -->
      <googleAnalytics
        :isOpen.sync="google_analytics_dialog"
        :title_dialog.sync="title_dialog"
        :closeConnectDialog="closeConnectDialog"
      />
      <facebookPixel
        :isOpen.sync="facebook_pixel_dialog"
        :title_dialog.sync="title_dialog"
        :closeConnectDialog="closeConnectDialog"
      />
      <googleTagManager
        :isOpen.sync="google_tag_manager_dialog"
        :title_dialog.sync="title_dialog"
        :closeConnectDialog="closeConnectDialog"
      />
      <googleAds
        :isOpen.sync="google_ads_dialog"
        :title_dialog.sync="title_dialog"
        :closeConnectDialog="closeConnectDialog"
      />
      <facebookCatalog
        :isOpen.sync="facebook_catalog_dialog"
        :title_dialog.sync="title_dialog"
        :closeConnectDialog="closeConnectDialog"
      />
      <yandex
        :isOpen.sync="yandex_dialog"
        :title_dialog.sync="title_dialog"
        :closeConnectDialog="closeConnectDialog"
      />
      <adstxt
        :isOpen.sync="adstxt_dialog"
        :title_dialog.sync="title_dialog"
        :closeConnectDialog="closeConnectDialog"
      />
      <!-- end -->

      <v-dialog v-model="alert" persistent max-width="450">
        <v-card>
          <v-card-title class="headline">{{
            $vuetify.lang.t("$vuetify.courseManagement.courseList.sorry")
          }}</v-card-title>
          <v-card-text>
            <div
              v-html="
                $vuetify.lang.t(
                  '$vuetify.courseManagement.courseList.alertPermissionFunction'
                )
              "
            ></div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text @click="alert = false">{{
              $vuetify.lang.t("$vuetify.courseManagement.courseList.ok")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      

      <v-dialog v-model="add_dialog" persistent max-width="700">
        <v-card>
          <v-card-title class="title justify-center"> Add Google Analytics </v-card-title>
          <v-card-text>
            <v-row justify="center" no-gutters>
              <v-col cols="8" class="ma-1">
                <v-card class="pa-2 body-2" height="40">
                  Google Analytic would like access to :</v-card
                >
              </v-col>
              <v-col cols="8">
                <v-select
                  class="body-2"
                  v-model="analytic"
                  :items="items"
                  menu-props="auto"
                  label="Select"
                  hide-details
                  single-line
                  dense
                  solo
                  height="40"
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn text x-small color="primary" @click="openInstructionDialog()">
              Instructions to connect
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              class="text-capitalize ma-1"
              outlined
              width="100"
              depressed
              color="primary"
              @click="add_dialog = false"
            >
              Close
            </v-btn>
            <v-btn
              class="text-capitalize ma-1"
              width="180"
              depressed
              color="primary"
              @click="openAddSetUpDialog"
            >
              Allow and Add
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="setup_dialog" persistent max-width="550">
        <v-card>
          <v-icon color="red">auto_graph</v-icon>
          <v-card-title class="title justify-center">
            Congrats! You Add Google Analytic
          </v-card-title>
          <v-card-subtitle>
            <div class="mt-3 text-center">
              Next, go to the Editor to check out the app on your site,
            </div>
            <div class="text-center">or start setting it up from your dashboard</div>
          </v-card-subtitle>
          <v-card-actions class="d-flex flex-column">
            <v-btn
              class="text-capitalize ma-1"
              width="150"
              depressed
              color="primary"
              @click="setup_dialog = false"
            >
              Go to Editor
            </v-btn>
            <v-btn
              class="text-capitalize ma-1"
              outlined
              width="100"
              depressed
              color="primary"
              @click="setup_dialog = false"
            >
              Set It Up
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row class="py-8">
      <v-col cols="0" sm="0" md="0" lg="1" xl="1"></v-col>
      <v-col cols="12" sm="12" md="12" lg="10" xl="10">
        <!-- TOOLS -->
        <div>
          <h1>Marketing Tools</h1>
          <h4>Use these tools to make your marketing more effective.</h4>
        </div>
        <div>
          <v-row class="pt-4">
            <!-- GOOGLE ANALYTICS -->
            <v-col cols="12" sm="12" md="6" lg="4" xl="4">
              <v-card class="toolcard" min-height="300px">
                <v-card-title class="pd-card-title">
                  <div>
                    <v-img
                      max-height="30.5px"
                      max-width="30.5px"
                      src="@/assets/marketing-tools/icon-googleanalytics.png"
                    ></v-img>
                  </div>
                  <span
                    class="pl-2 title font-weight-regular grey--text text--darken-2"
                    >{{ infoDialog.title_googleAnalytics }}</span
                  >
                </v-card-title>

                <v-divider />
                <v-card-subtitle class="pd-card-subtitle">
                  <span class=".subtitle-2 font-weight-medium">
                    Discover where your visitors come from and what they do on your site.
                  </span>
                </v-card-subtitle>
                <v-card-actions class="pa-0">
                  <v-btn
                    class="set-footer"
                    color="primary"
                    outlined
                    @click="openConnectDialog(infoDialog.type_googleAnalytics)"
                    >Connect</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-col>

            <!-- FACEBOOK PIXEL -->
            <v-col cols="12" sm="12" md="6" lg="4" xl="4">
              <v-card class="toolcard" min-height="300px">
                <v-card-title class="pd-card-title">
                  <div>
                    <v-img
                      max-height="30.5px"
                      max-width="30.5px"
                      src="@/assets/marketing-tools/icon-facebook.png"
                    ></v-img>
                  </div>
                  <span
                    class="pl-2 title font-weight-regular grey--text text--darken-2"
                    >{{ infoDialog.title_facebookPixel }}</span
                  >
                </v-card-title>

                <v-divider />
                <v-card-subtitle class="pd-card-subtitle">
                  <span class=".subtitle-2 font-weight-medium">
                    Track your Facebook campaigns, see conversion rates and more.
                  </span>
                </v-card-subtitle>
                <v-card-actions class="pa-0">
                  <v-btn
                    class="set-footer"
                    color="primary"
                    outlined
                    @click="openConnectDialog(infoDialog.type_facebookPixel)"
                    >Connect</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-col>

            <!-- GOOGLE TAG -->
            <v-col cols="12" sm="12" md="6" lg="4" xl="4">
              <v-card class="toolcard" min-height="300px">
                <v-card-title class="pd-card-title">
                  <div>
                    <v-img
                      max-height="30.5px"
                      max-width="30.5px"
                      src="@/assets/marketing-tools/icon-googleTag.png"
                    ></v-img>
                  </div>
                  <span
                    class="pl-2 title font-weight-regular grey--text text--darken-2"
                    >{{ infoDialog.title_googleTag }}</span
                  >
                </v-card-title>

                <v-divider />
                <v-card-subtitle class="pd-card-subtitle">
                  <span class=".subtitle-2 font-weight-medium">
                    Use Google Tag Manager to update tags and code on your website.
                  </span>
                </v-card-subtitle>
                <v-card-actions class="pa-0">
                  <v-btn
                    class="set-footer"
                    color="primary"
                    outlined
                    @click="openConnectDialog(infoDialog.type_googleTag)"
                    >Connect</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-col>

            <!-- GOOGLE ADS -->
            <v-col cols="12" sm="12" md="6" lg="4" xl="4">
              <v-card class="toolcard" min-height="300px">
                <v-card-title class="pd-card-title">
                  <div>
                    <v-img
                      max-height="30.5px"
                      max-width="30.5px"
                      src="@/assets/marketing-tools/icon-googleAds.png"
                    ></v-img>
                  </div>
                  <span
                    class="pl-2 title font-weight-regular grey--text text--darken-2"
                    >{{ infoDialog.title_googleAds }}</span
                  >
                </v-card-title>

                <v-divider />
                <v-card-subtitle class="pd-card-subtitle">
                  <span class=".subtitle-2 font-weight-medium">
                    Drive traffic back to your site with targeted remarketing ad
                    campaigns.
                  </span>
                </v-card-subtitle>
                <v-card-actions class="pa-0">
                  <v-btn
                    class="set-footer"
                    color="primary"
                    outlined
                    @click="openConnectDialog(infoDialog.type_googleAds)"
                    >Connect</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-col>

            <!-- FACEBOOK CATALOG -->
            <v-col cols="12" sm="12" md="6" lg="4" xl="4">
              <v-card class="toolcard" min-height="300px">
                <v-card-title class="pd-card-title">
                  <div>
                    <v-img
                      max-height="30.5px"
                      max-width="30.5px"
                      src="@/assets/marketing-tools/icon-facebook.png"
                    ></v-img>
                  </div>
                  <span
                    class="pl-2 title font-weight-regular grey--text text--darken-2"
                    >{{ infoDialog.title_facebookCatalog }}</span
                  >
                </v-card-title>

                <v-divider />
                <v-card-subtitle class="pd-card-subtitle">
                  <span class=".subtitle-2 font-weight-medium">
                    Promote your Wix Stores Products with dynamic Facebook ads.
                  </span>
                </v-card-subtitle>
                <v-card-actions class="pa-0">
                  <v-btn
                    class="set-footer"
                    color="primary"
                    outlined
                    @click="openConnectDialog(infoDialog.type_facebookCatalog)"
                    >Connect</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-col>

            <!-- YANDEX -->
            <v-col cols="12" sm="12" md="6" lg="4" xl="4">
              <v-card class="toolcard" min-height="300px">
                <v-card-title class="pd-card-title">
                  <div>
                    <v-img
                      max-width="150px"
                      src="@/assets/marketing-tools/icon-yandexMetrica.png"
                    ></v-img>
                  </div>
                  <!-- <span class="pl-2 title font-weight-regular grey--text text--darken-2"
                    >{{infoDialog.title_yandex}}</span
                  > -->
                </v-card-title>

                <v-divider />
                <v-card-subtitle class="pd-card-subtitle">
                  <span class=".subtitle-2 font-weight-medium">
                    Track your visitor activity with visual reports, video recordings and
                    more.
                  </span>
                </v-card-subtitle>
                <v-card-actions class="pa-0">
                  <v-btn
                    class="set-footer"
                    color="primary"
                    outlined
                    @click="openConnectDialog(infoDialog.type_yandex)"
                    >Connect</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-col>

            <!-- ADS TXT -->
            <v-col cols="12" sm="12" md="6" lg="4" xl="4">
              <v-card class="toolcard" min-height="300px">
                <v-card-title class="pd-card-title">
                  <div>
                    <v-img
                      max-height="50px"
                      max-width="50px"
                      src="@/assets/marketing-tools/icon-adstxt.png"
                    ></v-img>
                  </div>
                  <span class="pl-2 title font-weight-regular grey--text text--darken-2"
                    >{{infoDialog.title_adstxt}}</span
                  >
                </v-card-title>

                <v-divider />
                <v-card-subtitle class="pd-card-subtitle">
                  <span class=".subtitle-2 font-weight-medium">
                    Add your own ads.txt file and control who’s allowed to advertise on
                    your site.
                  </span>
                </v-card-subtitle>
                <v-card-actions class="pa-0">
                  <v-btn
                    class="set-footer"
                    color="primary"
                    outlined
                    @click="openConnectDialog(infoDialog.type_adstxt)"
                    >Connect</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </div>
        <!-- end -->

        <!-- APP -->
        <div class="py-4">
          <h1>Marketing App</h1>
          <h4>
            Check out just a few of the marketing apps you can use to grow your business.
          </h4>
        </div>
        <v-divider />
        <div>
          <v-row class="pt-8">
            <v-col cols="12" sm="12" md="4" lg="3" xl="3">
              <v-card class="pa-2">
                <div>
                  <v-img
                    max-height="100"
                    max-width="150"
                    src="@/assets/marketing-tools/icon-googleanalytics.png"
                  ></v-img>
                </div>
                <v-card-title class="py-0">Google Analytics</v-card-title>
                <v-card-text>By google</v-card-text>
                <v-card-subtitle class="py-0 pb-4">
                  Google Analytics allows you to track information.
                </v-card-subtitle>
                <v-card-actions>
                  <v-card-text class="px-0">20$/Month</v-card-text>
                  <v-btn color="primary" @click="add_dialog = true">Add</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </div>
        <!-- end -->
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="0" sm="0" md="0" lg="1" xl="2"></v-col>
      <v-col cols="12" sm="12" md="12" lg="10" xl="8"> </v-col>
    </v-row>
  </v-container>
</template>
<script>
import googleAnalytics from "./connectDialog/googleAnalytics.vue";
import facebookPixel from "./connectDialog/facebookPixel.vue";
import googleTagManager from "./connectDialog/googleTagManager.vue";
import googleAds from "./connectDialog/googleAds.vue";
import facebookCatalog from "./connectDialog/facebookCatalog.vue";
import yandex from "./connectDialog/yandex.vue";
import adstxt from "./connectDialog/adstxt.vue";
export default {
  name: "marketingtools",
  components: {
    googleAnalytics,
    facebookPixel,
    googleTagManager,
    googleAds,
    facebookCatalog,
    yandex,
    adstxt,
  },
  data() {
    return {
      // connect_dialog: false,

      google_analytics_dialog: false,
      facebook_pixel_dialog: false,
      google_tag_manager_dialog: false,
      google_ads_dialog: false,
      facebook_catalog_dialog: false,
      yandex_dialog: false,
      adstxt_dialog: false,

      add_dialog: false,
      setup_dialog: false,
      analytic: "Read basic site info",
      items: ["Read basic site info"],
      alert: false,
      toolType: "",
      title_dialog: "",

      infoDialog: {
        type_googleAnalytics: "googleAnalytics",
        type_facebookPixel: "facebookPixel",
        type_googleTag: "googleTagManager",
        type_googleAds: "googleAds",
        type_facebookCatalog: "facebookCatalog",
        type_yandex: "yandex",
        type_adstxt: "adstxt",

        title_googleAnalytics: "Google Analytics",
        title_facebookPixel: "Facebook Pixel",
        title_googleTag: "Google Tag Manager",
        title_googleAds: "Google Ads",
        title_facebookCatalog: "Facebook Catalog",
        title_yandex: "Yandex Metrica",
        title_adstxt: "Ads.txt",
      },
    };
  },
  beforeMount() {
    if (!this.$store.state.permission.adminCompany) {
      this.noPermission();
    }
  },
  methods: {
    noPermission() {
      // console.log("no permission");
      this.alert = true;
    },
    openConnectDialog(toolTypeItem) {
      this.toolType = toolTypeItem;
      this.setInfo();
      // this.connect_dialog = true;
    },
    openAddDialog(toolTypeItem) {
      this.toolType = toolTypeItem;
      this.add_dialog = true;
    },
    openInstructionDialog() {
      if (this.infoDialog.type_googleAnalytics == this.toolType) {
        this.google_analytics_dialog = true;
      } else if (this.infoDialog.type_facebookPixel == this.toolType) {
        this.facebook_pixel_dialog = true;
      } else if (this.infoDialog.type_googleTag == this.toolType) {
        this.google_tag_manager_dialog = true;
      } else if (this.infoDialog.type_googleAds == this.toolType) {
        this.google_ads_dialog = true;
      } else if (this.infoDialog.type_facebookCatalog == this.toolType) {
        this.facebook_catalog_dialog = true;
      } else if (this.infoDialog.type_yandex == this.toolType) {
        this.yandex_dialog = true;
      } else if (this.infoDialog.type_adstxt == this.toolType) {
        this.adstxt_dialog = true;
      }
    },
    setInfo() {
      if (this.infoDialog.type_googleAnalytics == this.toolType) {
        this.title_dialog = this.infoDialog.title_googleAnalytics;
        this.google_analytics_dialog = true;
      } else if (this.infoDialog.type_facebookPixel == this.toolType) {
        this.title_dialog = this.infoDialog.title_facebookPixel;
        this.facebook_pixel_dialog = true;
      } else if (this.infoDialog.type_googleTag == this.toolType) {
        this.title_dialog = this.infoDialog.title_googleTag;
        this.google_tag_manager_dialog = true;
      } else if (this.infoDialog.type_googleAds == this.toolType) {
        this.title_dialog = this.infoDialog.title_googleAds;
        this.google_ads_dialog = true;
      } else if (this.infoDialog.type_facebookCatalog == this.toolType) {
        this.title_dialog = this.infoDialog.title_facebookCatalog;
        this.facebook_catalog_dialog = true;
      } else if (this.infoDialog.type_yandex == this.toolType) {
        this.title_dialog = this.infoDialog.title_yandex;
        this.yandex_dialog = true;
      } else if (this.infoDialog.type_adstxt == this.toolType) {
        this.title_dialog = this.infoDialog.title_adstxt;
        this.adstxt_dialog = true;
      }
    },
    openAddSetUpDialog() {
      this.add_dialog = false;
      this.setup_dialog = true;
    },
    closeConnectDialog() {
      this.google_analytics_dialog = false;
      this.facebook_pixel_dialog = false;
      this.google_tag_manager_dialog = false;
      this.google_ads_dialog = false;
      this.facebook_catalog_dialog = false;
      this.yandex_dialog = false;
      this.adstxt_dialog = false;
      // this.toolType = "";
    },
  },
};
</script>
<style scoped>
.toolcard {
  padding: 30px !important;
}
.pd-card-title {
  padding-top: 0px !important;
  padding-bottom: 30px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.pd-card-subtitle {
  padding-top: 30px !important;
  padding-bottom: 0px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.set-footer {
  position: absolute;
  bottom: 30px;
  left: 30px;
}
.title-analytic {
  border-style: solid;
  border-width: 1px;
  border-color: whitesmoke;
  box-shadow: 2px 2px #cfcfcf;
}
</style>
